
module.exports = {
  pathPrefix: '/',
  siteUrl: 'https://www.365Knoten.de',
  siteTitle: 'Sven Sieverding',
  siteDescription: '365 Knoten...im Kopf',
  author: 'Sven Sieverding',
  postsForArchivePage: 3,
  defaultLanguage: 'de',
  disqusScript: '',
  pages: {
    home: '/',
    blog: 'blog',
    about: 'about',
    tag: 'tag',
    archive: 'archive'
  },
  social: {
    github: 'https://github.com/365knoten',
    linkedin: 'https://www.linkedin.com/in/sven-sieverding',
    xing: 'https://www.xing.com/profile/Sven_Sieverding',
    twitter: 'https://twitter.com/365Knoten',
    rss: '/rss.xml'
  },
  tags: {
    "Ich im Web": {
      description: 'Hier findet ihr mehr von mir im Web... Podcasts, Videos, etc.'
    },
    Theorie: {
      description: 'Artikel, die nette Zusammenhänge in der IT beschreiben'
    },
    "Power Automate": {
      description: 'Die Low Code Workflow Plattform von Microsoft'
    },
    "Power Apps": {
      description: 'Die Low Code Applikations Plattform von Microsoft'
    },
    Powershell: {
      description: 'Scripting unter Windows'
    },
    "Teams": {
      description: 'Die Kommunikationsplattform von Microsoft'
    },
    "SharePoint": {
      description: ''
    },
    "Quick Tip": {
      description: 'Ein paar schnelle Tipps und Tricks'
    },

    angular: {
      description: 'Angular is an open source web application platform.'
    },
    electron: {
      description: 'Electron is a framework for building cross-platform desktop applications with web technology.'
    },
    javascript: {
      description: 'JavaScript is an object-oriented programming language used alongside HTML and CSS to give functionality to web pages.'
    },
    laravel: {
      description: 'Laravel is a PHP framework for building web applications following the MVC pattern.'
    },
    nodejs: {
      name: 'Node.js',
      description: 'Node.js is a tool for executing JavaScript in a variety of environments.'
    },
    rxjs: {
      name: 'RxJS',
      description: 'RxJS is a library for reactive programming using Observables, to make it easier to compose asynchronous or callback-based code.'
    },
    sass: {
      description: 'Sass is a stable extension to classic CSS.'
    },
    typescript: {
      description: 'TypeScript is a typed superset of JavaScript that compiles to plain JavaScript.'
    },
    react: {
      description: 'React is an open source JavaScript library used for designing user interfaces.'
    },
    vuejs: {
      name: 'Vue.js',
      description: 'Vue.js is a JavaScript framework for building interactive web applications.'
    }
  }
}